import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { CompanyService } from './company/company.service';
import { EmployeeService } from './employee/employee.service';
import { DictionaryService } from './dictionary/dictionary.service';
import { InvoiceService } from './invoices/invoices.service';

export function provideApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    CompanyService,
    EmployeeService,
    DictionaryService,
    InvoiceService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ]);
}
